import React from 'react'
import { twMerge } from 'tailwind-merge'

interface BlockCategoryProps {
  label: string
  onClick?: () => void
  icon?: React.ReactNode
}

export const BlockCategory = ({ label, onClick, icon }: BlockCategoryProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        'flex w-full cursor-pointer items-center justify-start gap-1.5 hover:bg-btnSecondaryHover',
        'mb-2 rounded-md px-3 py-3 text-subheading-2 text-textPrimary transition-[all_0.3s_cubic-bezier(0,0,0.8,1)]',
      )}
      onClick={onClick}
    >
      <span className="h-5 w-5">{icon}</span>
      <div className="text-M">{label}</div>
    </button>
  )
}
